import { type Font as OpentypeFont, parse as parseOpentypeFont } from 'opentype.js'
import { logger } from '@/utils/logger'

/**
 * Parsed-font cache, keyed by WOFF file URL — the same font file is reused across every character
 * that shares it, and across repeated conversions in one session (fonts are re-fetched only once
 * per URL, mirroring the caching `font-loader.ts` already does for `FontFace` registration).
 */
export const parsedFontCache = new Map<string, Promise<OpentypeFont | null>>()

export async function loadOpentypeFont(woffFilePath: string): Promise<OpentypeFont | null> {
  const cached = parsedFontCache.get(woffFilePath)

  if (cached) return cached

  const pending = (async () => {
    try {
      const response = await fetch(woffFilePath)

      if (!response.ok) return null

      const buffer = await response.arrayBuffer()

      return parseOpentypeFont(buffer)
    } catch (error) {
      logger.warn('Failed to load font for text-to-shape conversion', { woffFilePath, error })
      return null
    }
  })()

  parsedFontCache.set(woffFilePath, pending)

  return pending
}
